var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalibriteColourStrip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2553.3 108.4",
    style: {
      enableBackground: "new 0 0 2553.3 108.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#735244;}\n\t.st1{fill:#C29682;}\n\t.st2{fill:#627A9D;}\n\t.st3{fill:#576C43;}\n\t.st4{fill:#8580B1;}\n\t.st5{fill:#67BDAA;}\n\t.st6{fill:#D67E2C;}\n\t.st7{fill:#505BA6;}\n\t.st8{fill:#C15A63;}\n\t.st9{fill:#5E3C6C;}\n\t.st10{fill:#9DBC40;}\n\t.st11{fill:#E0A32E;}\n\t.st12{fill:#383D96;}\n\t.st13{fill:#469449;}\n\t.st14{fill:#AE363C;}\n\t.st15{fill:#E7C71F;}\n\t.st16{fill:#BB5695;}\n\t.st17{fill:#0885A1;}\n\t.st18{fill:#F3F3F2;}\n\t.st19{fill:#C8C8C8;}\n\t.st20{fill:#A0A0A0;}\n\t.st21{fill:#7A7A79;}\n\t.st22{fill:#555555;}\n\t.st23{fill:#3C3C3B;}\n\t.st24{fill:#40983D;}\n\t.st25{fill:#005FAA;}\n\t.st26{fill:#BA0A2A;}\n\t.st27{fill:#FFD539;}\n\t.st28{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.4,
    className: "st1",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.8,
    className: "st2",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.2,
    className: "st3",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.6,
    className: "st4",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.9,
    className: "st5",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 638.3,
    className: "st6",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 744.7,
    className: "st7",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.1,
    className: "st8",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 957.5,
    className: "st9",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1063.9,
    className: "st10",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.3,
    className: "st11",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1276.7,
    className: "st12",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1383,
    className: "st13",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1489.4,
    className: "st14",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1595.8,
    className: "st15",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1702.2,
    className: "st16",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1808.6,
    className: "st17",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1915,
    className: "st18",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2021.4,
    className: "st19",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2127.8,
    className: "st20",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2234.2,
    className: "st21",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2340.6,
    className: "st22",
    width: 106.4,
    height: 108.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2446.9,
    className: "st23",
    width: 106.4,
    height: 108.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibriteColourStrip);
export default __webpack_public_path__ + "static/media/Calibrite-colour-strip.1a80cd12c63dcf492053eaf75d6539b0.svg";
export { ForwardRef as ReactComponent };